import { FC } from "react";
import { LogOut } from "lucide-react";

interface UserLogoutButtonProps {
  onLogout: () => void;
  isLoading?: boolean;
}

export const UserLogoutButton: FC<UserLogoutButtonProps> = ({
  onLogout,
  isLoading,
}) => {
  return (
    <div className="border-t border-gray-100 mt-2 pt-2">
      <button
        onClick={onLogout}
        disabled={isLoading}
        className="cursor-pointer flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-50 transition-colors group w-full text-left disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <LogOut className="w-4 h-4 text-red-600" />
        <span className="text-sm text-red-600 font-medium">
          {isLoading ? "Çıkış yapılıyor..." : "Çıkış Yap"}
        </span>
      </button>
    </div>
  );
};
